<template>
  <ErrorLayout>
    <p>こちらのべネアカウントでご利用可能なサービスはログイン画面が異なります。</p>
    <p>ご入力いただいたべネアカウントにて、再度下記専用ログイン画面よりログインください。</p>
    <p>
      専用ログイン画面：
      <a :href="loginUrl">{{ loginUrl }}</a>
    </p>
    <p>※ベネフィット・ステーション公式アプリはご利用いただけません。ブラウザでご利用ください。</p>
  </ErrorLayout>
</template>

<script>
import ErrorLayout from '@/views/pages/ErrorLayout/index.vue';

export default {
  components: {
    ErrorLayout,
  },
  data() {
    return {
      loginUrl: process.env.VUE_APP_CRM_LOGIN_URL
    }
  },
};
</script>
  
<style lang="scss"></style>
